import React, { useState, useEffect, useCallback } from "react";
import { Container, Box, ListItem, CircularProgress } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
  IconButton,
  List,
  Divider,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  Chip,
  Avatar,
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  Close,
  FilterList,
  CheckCircle,
  Block,
  SupervisedUserCircle,
  ArrowForwardIos,
  AccountBalance,
  Schedule,
  Money,
  VpnLock,
  AccountCircle,
  Settings,
  CallMade,
  CallReceived,
  InfoOutlined,
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import MUIDataTable from "mui-datatables";

import { makeStyles } from "@material-ui/styles";
import {
  FinanceService,
  AdminService,
  Validator,
} from "../../../../../utils/web_config";
import { useSnackbar } from "notistack";

import { Skeleton, Autocomplete } from "@material-ui/lab";

import SelectImg from "../../../../../assets/svg/select.svg";

import Nodata from "../../../../../assets/svg/nodata.svg";

import {
  useCommissionTypes,
  useTransactionTypes,
  useInternalAccounts,
  useOrganizations,
} from "../../../hooks/use_hooks";

const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));

function Transaction(props) {
  const classes = useStyles();
  const history = useHistory();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [accountData, setAccountData] = useState({});
  const [transactionData, setTransactionData] = useState({});

  const [transactions, setStransactions] = useState({
    page: 0,
    count: 1,
    rowsPerPage: 10,
    sortOrder: {},
    saving: false,
    loading: false,
    toggling: false,
    status: "Loading sub transactions...",
    data: [],
  });

  const [selectedAccount, setSelectedAccount] = useState({
    saving: false,
    loading: false,
    data: {},
  });

  const [reverse, setReverse] = useState({ open: false });
  const [reverseDescription, setDescription] = useState({
    value: "",
    error: "",
  });

  const [approver, setApprover] = useState({ value: "", error: "" })

  const [users, setUsers] = useState({
    page: 0,
    count: 1,
    rowsPerPage: 10,
    sortOrder: {},
    saving: false,
    loading: false,
    toggling: false,
    data: [],
  });

  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);
    setTransactionData(history.location.state);

    getTransactions(accountData.token, history.location.state.id);

    getUsers(accountData.token, accountData.organization?.organization_id);
  }, []);


  ///////////////////////

  const getUsers = (token, id) => {
    const usersInstance = axios.create(new AdminService().getHeaders(token));

    setUsers({ ...users, loading: true });

    usersInstance
      .get(new AdminService().GET_USERS_BY_TYPE + 'ORG_USER?size=10000')
      .then(function (response) {
        console.log(response.data.data)
        setUsers({ ...users, loading: false });

        const d = response.data;
        var usrs = [];

        d.data.forEach((u, i) => {
          const newUser = u;
          newUser["status2"] = u.user_status;
          newUser["user_names"] = u.user_first_name + " " + u.user_last_name;

          usrs.push(u);
        });

        setUsers({
          ...users,
          data: usrs,
        });
      })
      .catch(function (error) {
        setUsers({ ...users, loading: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }


        notify(error?.response?.status == 404 ? "info" : "error", e, error?.response?.status);
      });
  };


  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  const onDescriptionChange = (event) => {
    if (event.target.value === "") {
      setDescription({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("transaction.forms.hints.reverse_description")
            }
          </Translate>
        ),
      });
    } else {
      setDescription({ value: event.target.value, error: "" });
    }
  };

  const onApproverChange = (event) => {
    if (event.target.value === "") {
      setApprover({
        value: "",
        error: "Please Choose Approver",
      });
    } else {
      setApprover({ value: event.target.value, error: "" });
    }
  };

  const onReverseClick = () => {
    if (reverseDescription.value === "") {
      setDescription({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("transaction.forms.hints.reverse_description")
            }
          </Translate>
        ),
      });
    } 
    else if (approver.value === "") {
      setApprover({
        value: "",
        error: "Please choose approver",
      });
    } 
    else {
      reverseTransaction(transactionData.id);
    }
  };

  const capitalize = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };

  ////////////////////////////////////////////////////
  const transactionsColums = [
    {
      name: "tx_type",
      label: "Transaction type",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => (
          <Typography color={value == "CREDIT" ? "primary" : "error"}>
            {value}
          </Typography>
        ),
      },
    },
    {
      name: "account_number",
      label: "Account number",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "amount",
      label: "Amount",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => (
          <span>{new Validator().formatMoney(value)}</span>
        ),
      },
    },
    {
      name: "balance_before",
      label: "Before",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => (
          <span>{new Validator().formatMoney(value)}</span>
        ),
      },
    },
    {
      name: "balance_after",
      label: "After",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => (
          <span>{new Validator().formatMoney(value)}</span>
        ),
      },
    },
    {
      name: "tx_date",
      label: "Date",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "tx_time",
      label: "Time",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: function (dataI, rowI) {
          return (
            <Chip
              avatar={
                <Avatar>
                  {["completed", "confirmed"].includes(
                    transactions.data[dataI].status.toLowerCase()
                  ) ? (
                    <CheckCircle fontSize="small" />
                  ) : (
                    <Block fontSize="small" />
                  )}
                </Avatar>
              }
              variant="outlined"
              color={
                transactions.data[dataI].status.toLowerCase() == "completed"
                  ? "primary"
                  : "default"
              }
              size="small"
              label={capitalize(transactions.data[dataI].status)}
            />
          );
        },
      },
    },
  ];
  ///////////////////////////////////
  const transactionsOptions = {
    filterType: "multiselect",
    elevation: 0,
    selectableRows: "none",
    searchPlaceholder: "Search transaction...",
    selectableRowsOnClick: true,
    fixedHeader: true,
    onCellClick: (cellData, cellMeta) => {
      
      var trans = transactions.data[cellMeta.dataIndex];
      if(trans?.account_number!=null){
      getSelectedAccount(trans.account_number);
      }
    },
    searchProps: {
      variant: "outlined",
      margin: "dense",
    },
    textLabels: {
      body: {
        noMatch: transactions.status,
      },
    },
  };

  const getTransactions = (token, id) => {
    const usersInstance = axios.create(new AdminService().getHeaders(token));
   

    setStransactions({ ...transactions, loading: true });
    usersInstance
      .get(new FinanceService().SHOW_ACCOUNT_TRANSACTION + id + "&per_page=500")
      .then(function (response) {
        setStransactions({ ...transactions, loading: false });

        const d = response.data;

        if (d.data.length == 0) {
          setStransactions({
            ...transactions,
            status: "There are no sub transactions available",
          });
        } else {
          setStransactions({ ...transactions, data: d.data, allData: d.data });
        }
      })
      .catch(function (error) {
        setStransactions({ ...transactions, loading: false });
        if (error?.response?.status == 404) {
          setStransactions({
            ...transactions,
            status: "There are no sub transactions available",
          });
        }
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setStransactions({ ...transactions, status: e });
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  ////////////////////////////////////
  const reverseTransaction = (id) => {
    const updateInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setReverse({ ...reverse, saving: true });

    var data = {
      transaction_id: id,
      description: reverseDescription.value,
      approver: approver.value,
      request_type: "REVERSE_TRANSACTION",
      channel_type: "WEB"

    };

    updateInstance
      .post(new FinanceService().REQUEST_AGENT_TOPUP_TRANSACTION, data)
      .then(function (response) {
        setReverse({ ...reverse, saving: false, open: false });
        var d = response.data;

        setTransactionData(d.data);
        getTransactions(accountData.token, id);
        notify("success", response.data.message);
      })
      .catch(function (error) {
        setReverse({ ...reverse, saving: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };
  ///////////////////////////////////

  const getSelectedAccount = (acc) => {
    const agentsInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setSelectedAccount({ ...selectedAccount, loading: true, open: true });

    console.log("getting account .....");

    agentsInstance
      .get(new FinanceService().GET_ACCOUNT_PROFILE + acc)
      .then(function (response) {
        const d = response.data;
        setSelectedAccount({
          ...selectedAccount,
          loading: false,
          open: true,
          data: d.data,
        });
      })
      .catch(function (error) {
        setSelectedAccount({ ...selectedAccount, loading: false, open: true });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  return (
    <div className={classes.root}>
      {/* Dialogs ends here */}

      {/* //////////////////////// */}

      <Dialog
        open={selectedAccount.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={() =>
          setSelectedAccount({ ...selectedAccount, open: false, data: {} })
        }
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="alert-dialog-title">
          {selectedAccount.data.account_number_formatted}
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12} sm={12}>
              <Box display="flex" justifyContent="center" mt={2}>
                <Avatar style={{ height: 120, width: 120 }} />
              </Box>
              <List>
                {selectedAccount.loading ? (
                  [1, 2, 3, 4, 5, 2, 3, 4, 55].map((item, i) => (
                    <ListItem key={i}>
                      <ListItemText
                        primary={
                          <Skeleton
                            variant="text"
                            width={"100%"}
                            style={{ borderRadius: 7 }}
                          />
                        }
                      />
                    </ListItem>
                  ))
                ) : (
                  <>
                    <ListItem>
                      <ListItemIcon>
                        <AccountCircle />
                      </ListItemIcon>
                      <ListItemText primary="Account name:" />
                      <ListItemSecondaryAction>
                        <Typography variant="subtitle1" color="textSecondary">
                          {selectedAccount.data.account_name}
                        </Typography>
                      </ListItemSecondaryAction>
                    </ListItem>

                    <ListItem>
                      <ListItemIcon>
                        <Schedule />
                      </ListItemIcon>
                      <ListItemText primary="Wallet expire:" />
                      <ListItemSecondaryAction>
                        <Typography variant="subtitle1" color="textSecondary">
                          {selectedAccount.data.wallet_expiry_date}
                        </Typography>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <Money />
                      </ListItemIcon>
                      <ListItemText primary="Opening balance:" />
                      <ListItemSecondaryAction>
                        <Typography color="secondary">
                          <b>
                          {new Validator().formatMoney(
                    selectedAccount.data.opening_balance
                  )}
                           
                            {selectedAccount.data.currency_code}
                          </b>
                        </Typography>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <AccountBalance />
                      </ListItemIcon>
                      <ListItemText primary="Current balance:" />
                      <ListItemSecondaryAction>
                        <Typography color="primary">
                          <b>
                          {new Validator().formatMoney(
                    selectedAccount.data.current_balance
                  )}
                        
                            
                            {selectedAccount.data.currency_code}
                          </b>
                        </Typography>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <ListItem>
                      <ListItemIcon>
                        <Money />
                      </ListItemIcon>
                      <ListItemText primary="Closing balance:" />
                      <ListItemSecondaryAction>
                        <Typography color="secondary">
                          <b>
                          {new Validator().formatMoney(
                    selectedAccount.data.closing_balance
                  )}
                            
                            {selectedAccount.data.currency_code}
                          </b>
                        </Typography>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider variant="middle" />
                    <ListItem>
                      <ListItemText
                        primary={
                          selectedAccount.data.device_id != null
                            ? "Device ID"
                            : "Phone number"
                        }
                        secondary={selectedAccount.data.phone_number}
                      />
                    </ListItem>
                    {selectedAccount.data.wallet_id != null && (
                      <ListItem>
                        <ListItemText
                          primary="Wallet"
                          secondary={selectedAccount.data.wallet_id}
                        />
                      </ListItem>
                    )}
                  </>
                )}
              </List>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={() => {
              history.push("/centrika/accounts/details", selectedAccount.data);
            }}
          >
            Full account info
          </Button>
          <Button
            onClick={() => {
              setSelectedAccount({ ...selectedAccount, open: false });
            }}
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* //////////////////////// */}

      <Dialog
        open={reverse.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={() => setReverse({ ...reverse, open: false })}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="alert-dialog-title">
          Reverse this transaction
        </DialogTitle>
        <DialogContent>

          <Box mt={2}>
            <FormControl
              fullWidth
              variant="outlined"
              size="small"
              error={approver.error !== ""}
            >
              <InputLabel>
                Approver
              </InputLabel>
              <Select
                label={"Choose Approver"}
                value={approver.value}
                onChange={onApproverChange}
              >
                {users.data.filter(o => process.env.REACT_APP_APPROVERS.includes(o.user_name)).map((c, i) => (
                  <MenuItem value={c.user_id}>{c.user_names}</MenuItem>
                ))}
              </Select>
              <FormHelperText>{approver.error}</FormHelperText>
            </FormControl>
          </Box>
          
          <Box mt={2}>
            <Translate>
              {({ translate }) => (
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  type="text"
                  multiline
                  rows={4}
                  rowsMax={8}
                  value={reverseDescription.value}
                  placeholder={translate(
                    "transaction.forms.hints.reverse_description"
                  )}
                  label={
                    <Translate id="transaction.forms.labels.reverse_description" />
                  }
                  fullWidth
                  onChange={onDescriptionChange}
                  helperText={reverseDescription.error}
                  error={reverseDescription.error !== ""}
                />
              )}
            </Translate>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => {
              setReverse({ ...reverse, open: false });
            }}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              onReverseClick();
            }}
            color="primary"
            variant="contained"
            disableElevation
            disabled={reverse.saving}
            autoFocus
          >
            {reverse.saving ? <CircularProgress size={23} /> : "Request"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ////////////////////////// */}

      {/* /////////////////////////////////////// */}
      <Box display="flex" alignItems="center">
        <Box mr={2}>
          {" "}
          <SupervisedUserCircle color="primary" fontSize="large" />
        </Box>
        <Box flexGrow={1} display="flex" alignItems="center">
          <Typography variant="h5">
            <b>Transaction</b>
          </Typography>
          <Box ml={1} mr={1} mt={1}>
            <ArrowForwardIos fontSize="small" />
          </Box>
          <Typography variant="h6">Details</Typography>
        </Box>
      </Box>
      <Box mt={3} />
      <Grid container spacing={1}>
        <Grid item xs={12} md={4}>
          <Box style={{ padding: 50 }}>
            {transactionData.status != "REVERSED" && (
              <Button
                color="primary"
                variant="outlined"
                className={classes.btn}
                onClick={() => setReverse({ ...reverse, open: true })}
              >
                <Typography color="error">Request Reverse transaction </Typography>
              </Button>
            )}
            <List dense>
              <ListItem>
                <ListItemText
                  primary="Transaction type"
                  secondary={transactionData.tx_type_name}
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="Reference"
                  secondary={transactionData.reference_number}
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="Transaction external reference"
                  secondary={transactionData.external_reference_number}
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="Channel type"
                  secondary={transactionData.channel_type}
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="Debited account"
                  secondary={transactionData.debited_account}
                />
                <ListItemSecondaryAction><IconButton onClick={()=>{
                  getSelectedAccount(transactionData.debited_account.split("_").join(""));
                }}><InfoOutlined/></IconButton></ListItemSecondaryAction>
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="Credited account"
                  secondary={transactionData.credited_account}
                />
                <ListItemSecondaryAction><IconButton onClick={()=>{
                  getSelectedAccount(transactionData.credited_account.split("_").join(""));
                }}><InfoOutlined/></IconButton></ListItemSecondaryAction>
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="Transaction amount"
                  secondary={new Validator().formatMoney(
                    transactionData.amount
                  )}
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="Commission amount"
                  secondary={new Validator().formatMoney(
                    transactionData.total_commission_amount
                  )}
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="Transaction date"
                  secondary={transactionData.tx_date}
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="Transaction time"
                  secondary={transactionData.tx_time}
                />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="Transaction status"
                  secondary={transactionData.status}
                />
              </ListItem>
            </List>
          </Box>
        </Grid>
        <Grid item xs={12} md={8}>
          {transactions.loading && <LinearProgress />}

          <MUIDataTable
            title={"List of sub transactions"}
            data={transactions.data}
            columns={transactionsColums}
            options={transactionsOptions}
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default withLocalize(Transaction);
